import hall_bg from'../images/hall_bg.png'
import classroomTables_bg from'../images/classroomTables_bg.png'
import scene_greeting from'../images/scene_greeting.png'
import classroomMain_bg from'../images/classroomMain_bg.png'
import classroomMainCut_bg from'../images/classroomMainCut_bg.png'
import classroomMainCut_bg_presentation0 from'../images/classroomMainCut_bg_presentation0.png'
import classroomMainCut_bg_presentation1 from'../images/classroomMainCut_bg_presentation1.png'
import classroomMainCut_bg_presentation2 from'../images/classroomMainCut_bg_presentation2.png'
import classroomMainCut_bg_presentation3 from'../images/classroomMainCut_bg_presentation3.png'
import classroomMainCut_bg_presentation4 from'../images/classroomMainCut_bg_presentation4.png'
import classroomMainCut_bg_presentation5 from'../images/classroomMainCut_bg_presentation5.png'
import classroomMainCut_bg_presentation6 from'../images/classroomMainCut_bg_presentation6.png'
import stacyShowingPussy from'../images/stacyShowingPussy.png'
import ryderTakingOffJumper from'../images/ryderTakingOffJumper.png'
import ryderBendingOver from'../images/ryderBendingOver.png'
import ryderBendingOver2 from'../images/ryderBendingOver2.png'
import ryderBendingOver3 from'../images/ryderBendingOver3.png'
import ryderBendingOver4 from'../images/ryderBendingOver4.gif'
import ryderCloserLook from'../images/ryderCloserLook.png'
import wrongSlide_bg from'../images/wrongSlide_bg.gif'
import stacyOnTableArousedBG from'../images/stacyOnTableArousedBG.png'
import stacyOnTableArousedRightBG from'../images/stacyOnTableArousedRightBG.png'
import stacyOnTableArousedLeftBG from'../images/stacyOnTableArousedLeftBG.png'
import question1 from'../images/question1.png'
import question2 from'../images/question2.png'
import question3 from'../images/question3.png'
import question4 from'../images/question4.png'
import sheet from'../images/sheet.png'
import characters from'./characters';
import achievements from'./achievements';
import gallery from'./gallery';

const chapter1ru = [
  {novel:true, background:hall_bg, startCoordinates:0,
  script:[
  {char:characters["empty"],  position:"center", coordinates: 1, speed:0.8, transitionMode:"slow",
  phrases:[
    {text:"Прошло уже около двух недель как я учусь в универе"},
    {text:"Ничего особенного, просто учеба"},
    {text:"Я даже успел подружиться кое с кем"},
    {text:"Хотя обычно мне это сложно дается..."},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 100, speed:7, transitionMode:"slow",
  phrases:[
    {text:"О! А вот и он - мой новый друг"},
    {text:"Его зовут Вилли, как оказалось у нас много общего"},
    {text:"Как и я, он интересуется политикой, играми и сексом лол"},
    {text:"Есть ощущение, что он слегка озабоченный хех"},
    {text:"Кстати, он как раз таки и посоветовал мне этот майнор по секс просвету"},
    {text:"Кажется он его сильно ждет"},
    {text:"И еще где-то тут должна быть Фиби..."},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 60, speed:4, transitionMode:"slow",
  phrases:[
    {text:"Хм, странно"},
    {text:"Я видел ее совсем недавно..."},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Дик?", emotion:characters["willie"].neutral},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 55, speed:1,
  phrases:[
    {text:"Чо?!"},
    {text:"Откуда он тут взялся..."},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Ох, чел, не могу дождаться когда этот майнор начнется", emotion:characters["willie"].neutral},
    {text:"Я слышал, он вроде бы он экспериментальный!", emotion:characters["willie"].watchingPhone},
    {text:"Надеюсь, что преподша тоже будет открыта к экспериментам...", emotion:characters["willie"].snide},
    {text:"Если ты понимаешь, о чем я хехе", emotion:characters["willie"].snide},
    {text:"Думаю, что это будет грудастая милфа или попастая аспиранточка, которая только выпустилась ...", emotion:characters["willie"].snide},
    {text:"...", emotion:characters["willie"].surprised},
    {text:"Только не говори, что это она... Господь всемогущий...", emotion:characters["willie"].disgust},
  ]
  },
  {char:characters["oldLady"],  position:"right", coordinates: 65, speed:1.2,
  phrases:[
    {text:"Вы, ребята, ждете сексу.. В смысле, занятий по сексу?", emotion:characters["oldLady"].neutral},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Ага...", emotion:characters["willie"].disgust},
  ]
  },
  {char:characters["oldLady"],  position:"right", coordinates: 65, speed:1.2,
  phrases:[
    {text:"Хорошо.", emotion:characters["oldLady"].neutral},
    {text:"Ваша преподавательница сказала, что она скоро будет и вы можете в нее войти... то есть в комнату.. в класс", emotion:characters["oldLady"].neutral},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Хорошо, спасибо", emotion:characters["willie"].neutral},
  ]
  },
  {char:characters["oldLady"],  position:"right", coordinates: 65, speed:1.2,
  phrases:[
    {text:"В мое время юнцы и сами понимали, как дети делаются... Ох! Потерянное поколение..", emotion:characters["oldLady"].frustration},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Слава богу, это не она!", emotion:characters["willie"].neutral},
    {text:"Как будто бабули дома мне недостаточно", emotion:characters["willie"].watchingPhone},
  ]
  },
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"А ты что ли не видел фотку преподки на объявлении?", emotion:characters["dick"].neutral_right},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Ну, я как бы читал, а не просто пялился", emotion:characters["willie"].watchingPhone},
    {text:"И я сразу побежал писать мотивационное, так что...", emotion:characters["willie"].neutral},
    {text:"Так что, скажешь одногруппникам, что уже можно войти?", emotion:characters["willie"].neutral},
    {text:"Ты же знаешь, мне с этим тяжеловато", emotion:characters["willie"].watchingPhone, answers:["Позвать одногруппников", "Даа, вообще мне тоже"]},
  ]
  },

  ////Позвать одногруппников
  {option:"Позвать одногруппников", start:true},
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Ладно, я попробую...", emotion:characters["dick"].neutral_right},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 65, speed:1,
  phrases:[
    {text:"*набираюсь смелости чтобы заговорить*"},
  ]
  },
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Кхм", emotion:characters["dick"].neutral_right},
    {text:"Эээ, НАРОД, МОЖНО ЗАХОДИТЬ!", emotion:characters["dick"].rightYelling, achievement:achievements[0]},
    {text:"...", emotion:characters["dick"].rightTired},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 65, speed:1,
  phrases:[
    {text:"*Тишина*"},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"То, чего я и боялся", emotion:characters["willie"].watchingPhone},
  ]
  },
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Ладно, не думаю, что смогу это повторить...", emotion:characters["dick"].rightTired},
    {text:"Давай просто зайдем, думаю, они догадаются", emotion:characters["dick"].rightTired},
  ]
  },
  {option:"Позвать одногруппников", endOfOption:true},

  //Даа, вообще мне тоже
  {option:"Даа, вообще мне тоже", start:true},
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Даа, вообще мне тоже..", emotion:characters["dick"].rightTired},
    {text:"Давай просто зайдем, думаю, они догадаются", emotion:characters["dick"].rightTired},
  ]
  },
  {option:"Даа, вообще мне тоже", endOfOption:true,  endOfOptions:true},
  {endOfNovel:true}
]
},

{novel:true, background:classroomTables_bg, startCoordinates:100,
script:[
  {char:characters["empty"],  position:"center", coordinates: 60, speed:4, transitionMode:"slow",
phrases:[
  {text:"Ого..."},
  {text:"Это аудитория вообще или БДСМ дрочильня?"},
  {text:"Вдруг я увидел как кто-то машет мне рукой"},
]
},
{scene:true, img:scene_greeting, start:true, time:300},
{scene:true, name:characters["phoebe"].nameRu, position:"left",
phrases:[
  {text:"Ребята, я заняла нам места!!!"}
]},
{scene:true, name:characters["empty"].nameRu, position:"center",
phrases:[
  {text:"Это Фиби, она немного странная и как-будто не от мира сего"},
  {text:"Кажется, все что она делает ей просто по приколу"},
]},
{scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"Наконец-то вы пришли!", emotion:characters["phoebe"].laughing},
]
},
{char:characters["willie"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Тут так много... всякого лол", emotion:characters["willie"].sittingNeutral},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"Ага", emotion:characters["phoebe"].laughing},
  {text:"Даже слишком много", emotion:characters["phoebe"].smiling},
]
},

{char:characters["willie"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Ого, я только заметил...", emotion:characters["willie"].sittingSurprised},
  {text:"А они настоящие?", emotion:characters["willie"].sittingQuestion},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"Кто?", emotion:characters["phoebe"].smiling},
]
},
{char:characters["willie"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Тату...", emotion:characters["willie"].sittingQuestion},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"А! Не, это хна", emotion:characters["phoebe"].smiling},
  {text:"Решила сделать сегодня, она защищает меня от неудач", emotion:characters["phoebe"].laughing},
  {text:"В гороскопе написано, что у меня сегодня будет плохой день, если я не возьму все в свои руки", emotion:characters["phoebe"].neutral},
  {text:"Так что я сделала все, что могла!", emotion:characters["phoebe"].laughing},
]
},
{char:characters["dick"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Гороскопы...", emotion:characters["dick"].sittingNeutral, answers:["Ты реально веришь в это??", "А что написано в моем?"]},
]
},

//Ты реально веришь в это??
  {option:"Ты реально веришь в это??", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Ну, пока что они меня не подводили", emotion:characters["phoebe"].laughing, achievement:achievements[1]},

  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Нуу, вообще, не знаю, как по мне, лучший гороскоп - моя бабуля. Я всегда знаю, как пройдет день, просто взглянув на нее...", emotion:characters["willie"].sittingLookingToTheSide},
  ]
  },
  {option:"Ты реально веришь в это??", endOfOption:true},

  //А что написано в моем?
  {option:"А что написано в моем?", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Хмм, ты же весы, да?", emotion:characters["phoebe"].smiling},
    {text:"На сколько я помню, у тебя сегодня будет благоприятный день!", emotion:characters["phoebe"].smiling},
    {text:"Вот, написано: сегодня хороший день для работы руками, все ваши начинания хорошо кончат ся... Хм, кажется, опечатка", emotion:characters["phoebe"].laughing},
    {text:"Планировал сегодня что-то делать руками?", emotion:characters["phoebe"].smiling},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Думаю, я даже знаю ЧТО хехе", emotion:characters["willie"].sittingSnide},
    {text:"Нуу, вообще, не знаю, как по мне, лучший гороскоп - моя бабуля. Я всегда знаю, как пройдет день, просто взглянув на нее...", emotion:characters["willie"].sittingLookingToTheSide},
  ]
  },

  {option:"А что написано в моем?", endOfOption:true, endOfOptions:true},
  //


  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Ахах", emotion:characters["phoebe"].laughing},
    {text:"...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"Ну привет, не ожидала тебя тут увидеть, сестричка", emotion:characters["ursula"].standingNeutral},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Да, я тоже не ожидала, что такая дура, как ты, задержится тут надолго...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"КАК ТЫ МЕНЯ НАЗВАЛА?", emotion:characters["ursula"].standingAngry},
    {text:"ДА Я, Я...", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Чао персик, дозревай", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"Я с тобой еще не закончила!", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Эй, иди умойся уже рожа намалеванная...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"САМА УМОЙСЯ!", emotion:characters["ursula"].standingAngry2},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"ТЫ СОВСЕМ УЖЕ ОХУЕЛА??", emotion:characters["phoebe"].sittingCoffeeShocked},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"А что? Ты сама напросилась!", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["stacy"],  position:"right", coordinates: 10, speed:1, destinationPoint:[-25, -5, 0, -5],
  phrases:[
    {text:"Пойдем, Урсула, она того не стоит", emotion:characters["stacy"].sittingNeutral},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"В СЛЕДУЮЩИЙ РАЗ Я ТЕБЕ ГЛАЗ НА ЖОПУ НАТЯНУ!", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Сучка...", emotion:characters["phoebe"].sittingAngry},
    {text:"Теперь я вся мокрая...", emotion:characters["phoebe"].sittingAngry},
    {text:"Кажется это был латте, латте со льдом", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"Я не слишком... плохо выгляжу теперь?", emotion:characters["phoebe"].sittingQuestionCoffee, answers:["Нуу.. Я бы сказал, что в этом что-то есть","Не плохо, но немного откровенно..."]},
  ]
  },

  //Нуу.. Я бы сказал, что в этом что-то есть
  {option:"Нуу.. Я бы сказал, что в этом что-то есть", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Ахах, спасибо, я тоже так думаю", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Я теперь и пахну как кофе! Плюс вайб", emotion:characters["phoebe"].sittingSmilingCoffee},
  ]
  },
  {option:"Нуу.. Я бы сказал, что в этом что-то есть", endOfOption:true},
  //

  //Не плохо, но немного откровенно...
  {option:"Не плохо, но немного откровенно...", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Ну и ладно.. Тогда, думаю, все окей", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Выглядишь просто супер! В смысле, нормально...", emotion:characters["willie"].sittingSnide},
  ]
  },
  {option:"Не плохо, но немного откровенно...", endOfOption:true, endOfOptions:true},
  //
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Я даже и не знал, что у тебя есть сестра!", emotion:characters["willie"].sittingSurprised},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Если честно, лучше бы ее не было", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Совсем нехороший день, гороскоп был прав!", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Терпеть ее не могу, она всегда была такой", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Как обычно... Портит мою жизнь", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Как в последний раз, когда мы были с... и она...", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Ладно, забейте, давайте сменим тему!", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"Жду не дождусь начала!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"И я! Мне кажется, я даже слегка вспотел...", emotion:characters["willie"].sittingSweating, answers:["Я тоже! В смысле жду!","Я все еще не уверен, что будет что-то интересное..."]},
  ]
  },

  //Я тоже! В смысле жду!
  {option:"Я тоже! В смысле жду!", start:true},
  {char:characters["profryderhidden"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"А я то как жду!", emotion:characters["profryderhidden"].standingHidden},
  ]
  },
  {option:"Я тоже! В смысле жду!", endOfOption:true},

  //Я все еще не уверен, что будет что-то интересное...
  {option:"Я все еще не уверен, что будет что-то интересное...", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Да ладно тебе, письки это всегда прикольно!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["profryderhidden"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Не могу не согласиться!", emotion:characters["profryderhidden"].standingHidden},
  ]
  },
  {option:"Я все еще не уверен, что будет что-то интересное...", endOfOption:true, endOfOptions:true},
  //
  {endOfNovel:true}
]
},




{novel:true, background:classroomMain_bg, startCoordinates:0,
script:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:3,
phrases:[
  {text:"Такс, ну давайте начнем!", emotion:characters["profryder"].standingSmiling},
  {text:"Меня зовут мисс Райдер, я буду вашей преподавательницей", emotion:characters["profryder"].standingSmiling},
]
},
{char:characters["willie"],  position:"left", coordinates: 20, speed:1,
phrases:[
  {text:"<small><i>Я же говорил...</small></i>", emotion:characters["willie"].sittingSnide},
  {text:"<small><i>Она как из Хогвартса с этой “палочкой”</small></i>", emotion:characters["willie"].sittingNeutral},
  {text:"<small><i>Вот бы она скастовала на меня свой шпиликус-виликус хехе</small></i>", emotion:characters["willie"].sittingSnide},
]
},
{char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
phrases:[
  {text:"Можете считать меня подругой", emotion:characters["profryder"].standingSmiling},
  {text:"Но не забывайте, что я все еще преподавательница!", emotion:characters["profryder"].standingSmiling},
  {text:"Так, нуу, думаю, вам хотелось бы узнать меня немного поближе", emotion:characters["profryder"].standingSmiling},
  {text:"Недавно я выпустилась и тепрь я магисторка по психологии с уклоном в сексологию", emotion:characters["profryder"].standingSmiling},
  {text:"Сейчас планирую получать PhD!", emotion:characters["profryder"].standingSmiling},
  {text:"И нет, не тот PhD о котором вы могли подумать, а кандидатскую!", emotion:characters["profryder"].standingLaughing},
  {text:"Я сейчас пишу диссертацию и надеюсь, что наши занятия помогут мне собрать больше информации и получить преподовательский опыт", emotion:characters["profryder"].standingNeutral},
  {text:"Я старалась построить курс так, чтобы помочь вам преодолеть трудности в сексе и стать настоящими секс мастерами и мастерицами!", emotion:characters["profryder"].standingLaughing},
  {text:"И еще - мне бы очень не хотелось, чтобы вы оставались со своими проблемами наедине", emotion:characters["profryder"].standingNeutral},
  {text:"Поэтому если у вас есть какие-либо вопросы, можете их задать. Постараюсь вас удовлетворить ответами!", emotion:characters["profryder"].standingSmiling},
]
},

{char:characters["howard"],  position:"left", coordinates: 20, speed:1,
phrases:[
  {text:"ДАЙТЕ СЕКС!!!", emotion:characters["howard"].sittingNeutral},
]
},

{char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
phrases:[
  {text:"Хаха, всему свое время, молодой человек!", emotion:characters["profryder"].standingLaughing},
  {text:"Еще я бы хотела попросить вас всех поддерживать на занятиях дружелюбную и свободную для общения и обсуждения атмосферу", emotion:characters["profryder"].standingSmiling},
  {text:"Так что давайте постараемся не осуждать друг друга", emotion:characters["profryder"].standingSmiling},
  {text:"Ну, теперь ближе к делу, а начнем мы с анатомии!", emotion:characters["profryder"].standingSmiling},
  {text:"Думаю, это основа основ", emotion:characters["profryder"].standingSmiling},
  {text:"Зная ее, нам будет легче углубляться в более сложные вещи и не навредить себе и партнеру!", emotion:characters["profryder"].standingLaughing},
  {text:"Тема достаточно обширная, но я дам вам только разработанный мною краткий курс с самым важным", emotion:characters["profryder"].standingSmiling},
]
},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:2.3, noBlur:true, destinationPoint:[-25,-15, -10,-15], appearAfterMoving:true,
phrases:[
  {text:"Ну что ж, кто может сказать, что это?", emotion:characters["profryder"].standingLaughing},
]
},
{char:characters["howard"],  position:"left", coordinates: 0, speed:1, destinationPoint:[-15,-10, 0, -10],
phrases:[
  {text:"РОДИЛЬНОЕ ОТВЕРСТИЕ!", emotion:characters["howard"].sittingNeutral},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 0, speed:1, destinationPoint:[-15,-10, 0, -10],
phrases:[
  {text:"Ахах", emotion:characters["phoebe"].sittingLaughingCoffee},
]
},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Еще варианты?", emotion:characters["profryder"].standingLaughing},
]
},
{char:characters["willie"],  position:"left", coordinates: 0, speed:1, destinationPoint:[-15,-10, 0, -10],
phrases:[
  {text:"<small><i>Пусси</small></i>", emotion:characters["willie"].sittingSnide},
]
},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Можно и так сказать", emotion:characters["profryder"].standingLaughing},
  {text:"Но мне хотелось бы услышать анатомическое название", emotion:characters["profryder"].standingEyebrowsUp, answers:["Клитор","Вульва","Половые губы"]},
]
},

//Клитор
{option:"Клитор", start:true},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Да, он тут тоже есть, но только как часть того, что называется вульвой", emotion:characters["profryder"].standingSmiling},
]
},
{option:"Клитор", endOfOption:true},
//Вульва
{option:"Вульва", start:true},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Молодец, правильно! ", emotion:characters["profryder"].standingLaughing, achievement:achievements[2]},
]
},
{option:"Вульва", endOfOption:true},
//Половые губы
{option:"Половые губы", start:true},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Да, они и правда тут сильно выделаются, но они только часть того, что называется вульвой!", emotion:characters["profryder"].standingSmiling},
]
},
{option:"Половые губы", endOfOption:true, endOfOptions:true},
//

{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Простыми словами, вульва - внешняя часть женских гениталий", emotion:characters["profryder"].standingSmiling},
  {text:"Давайте погрузимся в нее чуть глубже!", emotion:characters["profryder"].standingSmiling},
  {text:"Слушайте внимательно, в конце занятия вас ждет небольшой тест", emotion:characters["profryder"].standingSmiling},
  {text:"А после будет практическая часть, где вам придется поработать не только головой, но и руками!", emotion:characters["profryder"].standingSmiling},
]
},
{endOfNovel:true},
]
},

{novel:true, background:classroomMainCut_bg_presentation0, startCoordinates:0,
script:[
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:3, noBlur:true, destinationPoint:[-25,-15, -15, -15], appearAfterMoving:true,
  phrases:[
    {text:"Итак, добро пожаловать в аппетитный мир вульв!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation1, gallery:gallery[1]},
  {char:characters["profryder"],  position:"right", startCoordinates:0, coordinates: 100, speed:0.5, noBlur:true, destinationPoint:[-25,-15,-15,-15], appearAfterMoving:true,
  phrases:[
    {text:"То, что мы обычно видим первым называется большие половые губы", emotion:characters["profryder"].standingSmiling},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Так бы их и расцеловал, хехе!", emotion:characters["howard"].sittingSnide},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"...", emotion:characters["profryder"].standingSurprised},
    {text:"Они состоят из обычной кожи и могут быть телесного цвета или чуть темнее", emotion:characters["profryder"].standingNeutral},
    {text:"Сразу за ними мы можем увидеть малые половые губы", emotion:characters["profryder"].standingNeutral},
    {text:"Обычно они розовые или коричневые, в зависимости от цвета кожи...", emotion:characters["profryder"].standingBlushed},
    {text:"Вместе с большими они выполняют защитную функцию", emotion:characters["profryder"].standingNeutral},
    {text:"Но что же именно они защищают?", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation2, gallery:gallery[2]},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Вот эту область, которая называется преддверием влагалища", emotion:characters["profryder"].standingNeutral},
    {text:"Она включает в себя:", emotion:characters["profryder"].standingNeutral},
    {text:"Железы, например, малые вестибулярные, которые, кстати говоря, работают схоже с мужской простатой", emotion:characters["profryder"].standingSmiling},
    {text:"Считается, что они обеспечивают женскую эякуляцию, то есть сквирт, но это пока не доказано...", emotion:characters["profryder"].standingBlushed},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>Вау, я правда узнаю что-то новенькое!</small></i>", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"С другой стороны, это лишь дает нам больше возможностей для экспериментов! У нас точно должно быть занятие на эту тему!", emotion:characters["profryder"].standingLaughing},
  ]
  },

  //
  {changeBG:true, img:wrongSlide_bg, gallery:gallery[3]},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Оой!", emotion:characters["profryder"].standingBlushed},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Оо даа, детка, погладь свою киску!", emotion:characters["howard"].sittingSnide},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Прошу прощения, это должно было быть в... в практической части", emotion:characters["profryder"].standingBlushed},
    {text:"Думаю мне… не стоило делать презентацию в 2 часа ночи!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>Интересно, она и этот гайд сама делала...</small></i>", emotion:characters["willie"].sittingSnide},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 75, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>Ахах, да, 100 процентов</small></i>", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Так, эмм.. Вернемся к нашим баранам!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation2},
  //
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Мы также можем увидеть тут большие вестибулярные железы, из которых выделяется смазка во время возбуждения", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Мы еще вернемся к ним сегодня во время практики, так что прошу вас обратить на них особое внимание!", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>Уже дождаться не могу практики...</small></i>", emotion:characters["willie"].sittingSnide},
  ]
  },
  {char:characters["dick"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Эээ...", emotion:characters["dick"].sittingNeutral, answers:["Вообще, думаю, теория тоже важна","Дааа... Терпеть не могу лекции"], warning:"Этот выбор повлияет на дальнейший <br/> ход лекции"},
  ]
  },

  //Дааа... Терпеть не могу лекции
  {option:"Дааа... Терпеть не могу лекции", start:true},
  {char:characters["dick"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Даа.. Еще чуть-чуть и я вырублюсь...", emotion:characters["dick"].sittingSleepy},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Уретра, из которой мы писаем", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"И...", emotion:characters["profryder"].standingDisgusted},
    {text:"?", emotion:characters["profryder"].standingDisgusted},
    {text:"Ох, Ричард, я смотрю ты заскучал...", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Хм, тут и правда немного душновато и жарковато, да, ребята?", emotion:characters["profryder"].standingLaughing},
    ]
  },

  {scene:true, img:ryderTakingOffJumper, start:true, time:300, gallery:gallery[4]},
  {scene:true, name:characters["profryder"].nameRu,  position:"center",
  phrases:[
    {text:"Думаю, кофточку можно снять, так должно быть полегче..."},
  ]
  },
  {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},

  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"И нам определенно нужен свежий воздух", emotion:characters["profryder"].standingLaughingShirt},
    {text:"Я же не могу дать вам заскучать!", emotion:characters["profryder"].standingSmilingShirt},
    {text:"Так.. На чем же мы остановились...", emotion:characters["profryder"].standingQuestionShirt},
    {text:"А, точно, вагина!", emotion:characters["profryder"].standingLaughingShirt},
    {text:"Сейчас покажу вам где она находится", emotion:characters["profryder"].standingEyebrowsUpShirt},
    {text:"...", emotion:characters["profryder"].standingDroppedStick},
    ]
  },
  {char:characters["empty"],  position:"center", coordinates: 100, speed:1, noBlur:true,
  phrases:[
    {text:"*стук*"},
    ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Ооох ну надо же!", emotion:characters["profryder"].standingDroppedSurprised},
    {text:"Какая я неуклюжая! Кажется, я уронила свою указку...", emotion:characters["profryder"].standingDroppedSurprised},
    {text:"Теперь мне придется нагнуться и поднять ее!", emotion:characters["profryder"].standingDroppedBlushed},
    ]
  },
  {scene:true, img:ryderBendingOver, start:true, time:800},
  {scene:true, name:characters["profryder"].nameRu,  position:"left",
  phrases:[
    {text:"Хм?"},
    {text:"Ричард! Я вижу куда ты смотришь!"},
    {text:"Зато.. Хотя бы теперь ты внимателено слушаешь!"},
    {text:"Собственно..."},
  ]
  },
  {scene:true, img:ryderBendingOver2, changeScene:true},
  {scene:true, name:characters["profryder"].nameRu,  position:"left",
  phrases:[
    {text:"Вагина находится вот тут"},
  ]
  },
  {scene:true, img:ryderBendingOver3, changeScene:true},
  {scene:true, name:characters["profryder"].nameRu,  position:"left",
  phrases:[
    {text:"Чуть ниже моей попки"},
  ]
  },
  {scene:true, img:ryderBendingOver4, changeScene:true, gallery:gallery[5]},
  {scene:true, name:characters["profryder"].nameRu,  position:"left", dialogCoordinates:"65vh",
  phrases:[
    {text:"А помнишь, как называются эти сладкие булочки?", answers:["Малые половые губы","Большие половые губы"]},
  ]
  },
  {option:"Малые половые губы", start:true},
  {scene:true, img:ryderBendingOver, changeScene:true},
  {scene:true, name:characters["profryder"].nameRu,  position:"left", dialogCoordinates:"60vh",
  phrases:[
    {text:"Ах, дорогуша, кажется тебе не помешает остаться после занятий..."},
    {text:"Я бы провела для тебя особую лекцию!"},
  ]
  },
  {option:"Малые половые губы", endOfOption:true},

  {option:"Большие половые губы", start:true},
  {scene:true, img:ryderBendingOver, changeScene:true},
  {scene:true, name:characters["profryder"].nameRu,  position:"left", dialogCoordinates:"60vh",
  phrases:[
    {text:"Молодец, Ричард!"},
    {text:"Схватываешь на лету!"},
    {text:"Знаешь, я ОЧЕНЬ люблю умных студентов"},
  ]
  },
  {option:"Большие половые губы", endOfOption:true, endOfOptions:true, subEnd:true},
  {scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},

  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Ну хорошо...", emotion:characters["profryder"].standingSmilingShirt},
    {text:"Теперь перейдем к самой чувстивтельной и интригующей части вульвы", emotion:characters["profryder"].standingSmilingShirt},
    ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation4, gallery:gallery[6]},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
phrases:[
  {text:"Клитору!", emotion:characters["profryder"].standingLaughingShirt},
  {text:"Эта маленькая штучка помогает мне... Точнее, девушкам... чувствовать себя очень-очень хорошо, когда ее трогают...", emotion:characters["profryder"].standingEyebrowsUpShirt},
  {text:"Особенно если ее трогает", emotion:characters["profryder"].standingEyebrowsUpShirt},
  {text:"Ричард!", emotion:characters["profryder"].standingQuestionShirt},
  {text:"Мои глаза находятся чуть выше!", emotion:characters["profryder"].standingQuestionShirt},
  {text:"Ладно, видимо, единственный способ сделать так, чтобы ты и правда слушал - это дать тебе", emotion:characters["profryder"].standingEyebrowsUpShirt},
  {text:"Посмотреть поближе", emotion:characters["profryder"].standingSmilingShirt},
  ]
},
{scene:true, img:ryderCloserLook, start:true, time:800, dialogCoordinates:"50vh", gallery:gallery[7]},
  {scene:true, name:characters["profryder"].nameRu,  position:"center",
  phrases:[
    {text:"Ну что..."},
    {text:"Нравится?..."},
    {text:"Они такие большие и мягкие"},
    {text:"Такие влажные от того внимания которое ты уделял им все занятие, Ричард..."},
    {text:"Думаешь, я не видела как ты на них смотришь, как представляешь свой член между ними"},
    {text:"Скользящими по нему вверх и вниз, вверх и вниз..."},
    {text:"Ну как я могу продолжать лекцию"},
    {text:"Если мне тоже так этого хочется, Ричард..."},
    {text:"Ричард?"},
    {text:"Ричард?"},
  ]
  },
  {scene:true, endOfScene:true, time:1200, endOfSceneLoadNext:true, dialogCoordinates:"60vh"},

  {changeBG:true, img:classroomMainCut_bg_presentation6, gallery:gallery[8]},

  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Ричард, ты с нами?", emotion:characters["profryder"].standingQuestion, achievement:achievements[15]},
    {text:"Надеюсь, ты хорошо меня слушал, сейчас у нас будет небольшой тест...", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Такс..", emotion:characters["profryder"].standingNeutral},
    {text:"Ах да! Пока я раздаю вам тесты, можете посмотреть на разные вульвы на доске", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"И запомните - все они уникальны и красивы, в них нечего стыдиться", emotion:characters["profryder"].standingEyebrowsUp},
    ]
  },

  {option:"Дааа... Терпеть не могу лекции", endOfOption:true},

  //Вообще, думаю, теория тоже важна
  {option:"Вообще, думаю, теория тоже важна", start:true},
  {char:characters["dick"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Да давай послушаем!", emotion:characters["dick"].sittingNeutral},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Уретра, из нее мы писаем", emotion:characters["profryder"].standingNeutral},
    {text:"И вагина, про которую у нас будет отдельная лекция, так что подробнее разберем ее чуть позже!", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Ну а теперь к десерту!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation3},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Кто знает, что это за маленькая штучка?", emotion:characters["profryder"].standingSmiling},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Не знаю, как вы, но я называю ее фасолинка", emotion:characters["howard"].sittingNeutral},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Аггх...", emotion:characters["ursula"].sittingDisgusted},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Обычно ее называют клитором", emotion:characters["profryder"].standingSmiling},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation4, gallery:gallery[6]},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"А вот тут, чуть выше, находится капюшон клитора, который прикрывает его когда женщина не возбуждена", emotion:characters["profryder"].standingSmiling},
    {text:"Кто-нибудь знает, зачем вообще нужен клитор?", emotion:characters["profryder"].standingQuestion},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 100, speed:1,
  phrases:[
    {text:"*Тишина*"},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Девушки, не стесняйтесь, что вы чувствуете, когда трогаете его?", emotion:characters["profryder"].standingSmiling},
    {text:"Урсула, кажется, в письме ты немного описывала свой опыт, будет очень здорово, если поделишься сейчас!", emotion:characters["profryder"].standingQuestion},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 75, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Зависит от настроя..", emotion:characters["ursula"].sittingNeutral},
    {text:"Иногда это может быть даже и неприятно", emotion:characters["ursula"].sittingNeutral},
    {text:"Но обычно...", emotion:characters["ursula"].sittingNeutral},
    {text:"Ощущения, типа приятные...", emotion:characters["ursula"].sittingWhatever},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Да, эта кнопочка может как причинить вам боль, так и доставить удовольствие...", emotion:characters["profryder"].standingNeutral},
    {text:"Зависит от того, что и когда вы с ней делаете", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Вообще, клитор - это скопление нервов, ответственных за возбуждение и оргазм", emotion:characters["profryder"].standingNeutral},
    {text:"Только представьте - головка клитора содержит около 10 тысяч нервных окончаний!", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"В то время как у головки пениса их всего 4 тысячи!", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"И ВСЕ РАВНО МЫ ЛУЧШЕ!", emotion:characters["howard"].sittingNeutral},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Конечно-конеечно, как скажешь, солнышко...", emotion:characters["profryder"].standingDisgusted},
    {text:"Поэтому не удивительно, что женский оргазм гораздо сильнее!", emotion:characters["profryder"].standingSmiling},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation5},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"И горошинка, которую мы видим снаружи, лишь верхушка айсберга, на самом деле клитор выглядит так!", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Ножки по бокам и луковицы преддверия помогают возбуждению во время вагинального проникновения", emotion:characters["profryder"].standingSmiling},
    {text:"Вообще, фактически, все оргазмы, которые могут испытывать женщины, являются клиторальными с анатомической точки зрения...", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Даже анальный?!", emotion:characters["howard"].sittingNeutral},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Мы углубимся в эту тему попозже", emotion:characters["profryder"].standingLaughing},
    {text:"Пока могу сказать, что это все равно непрямая стимуляция клитора", emotion:characters["profryder"].standingSmiling},
    {text:"Хочу отметить, что клиторы бывают абсолютно разными", emotion:characters["profryder"].standingSmiling},
    {text:"Разного цвета, размера самого клитора и капюшона", emotion:characters["profryder"].standingSmiling},
    {text:"Забегая немного вперед, скажу, что он увеличивается, когда женщина возбуждена, это называется клиторальной эрекцией", emotion:characters["profryder"].standingSmiling},
    {text:"Ну а перед тем, как перейти к разговору о возбуждении и практике, давайте пройдем небольшой тест!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation6, gallery:gallery[8]},
{char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Ах, да, чуть не забыла, пока я раздаю вам тесты, можете посмотреть на разные вульвы на доске! И запомните - все они уникальны и красивы, их не за что стыдиться", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {option:"Вообще, думаю, теория тоже важна", endOfOption:true, endOfOptions:true},

  {char:characters["empty"],  position:"center", coordinates: 80, speed:2, transitionMode: "slow",
  phrases:[
    {text:"*Мисс Райдер пошла раздавать тесты*"}
  ]
  },
  {endOfNovel:true}
]
},

{novel:true, background:classroomTables_bg, startCoordinates:20,
script:[
  {char:characters["ursula"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"У меня один в один как на третьей картинке", emotion:characters["ursula"].sittingSurprised},
  ]
  },
  {char:characters["stacy"],  position:"right", coordinates: 20, speed:1, destinationPoint:[-25, -5, 0, -5],
  phrases:[
    {text:"Хм.. Не уверена на какую у меня больше похоже, можешь посмотреть?", emotion:characters["stacy"].sittingNeutral},
  ]
  },
  {scene:true, img:stacyShowingPussy, start:true, time:800, gallery:gallery[9]},
  {scene:true, name:characters["ursula"].nameRu,  position:"left",
  phrases:[
    {text:"Ммм, думаю, на четвертую"}
  ]
  },
  {scene:true, name:characters["howard"].nameRu,  position:"left",
  phrases:[
    {text:"Если хотите мнения реального эксперта по писечкам, рекоммендую показать мне!!!"},
  ]
  },
  {scene:true, endOfScene:true, time:100, endOfSceneLoadNext:true},
  {char:characters["stacy"],  position:"right", coordinates: 20, speed:1, destinationPoint:[-25, -5, 0, -5],
  phrases:[
    {text:"Говард, завали ебало!", emotion:characters["stacy"].sittingAngry},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Чуваак, настоящая женская вагина! То есть вульва...", emotion:characters["willie"].sittingLookingToTheSide},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Офигеть, она такая...", emotion:characters["phoebe"].sittingSurprisedCoffee},
    {text:"Смелая", emotion:characters["phoebe"].sittingSurprisedCoffee},
    {text:"Хмм.. Попробуешь угадать, какая похожа на мою?", emotion:characters["phoebe"].sittingLaughingCoffee, answers:["2","3","7"]},
  ]
  },
  //2
  {option:"2", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Ммм, ну что-то похожее есть!", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"Хахаха, я не думала, что ты правда будешь угадывать!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Ты что, не видел надпись? Все вульвы уникальны!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Но если реально хочешь знать...", emotion:characters["phoebe"].sittingThinkingCoffee},
    {text:"Тут тяжело найти что-то похожее...", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"Я бы сказала она немного похожа на бургер", emotion:characters["phoebe"].sittingNeutralCoffee},
  ]
  },
  {option:"2", endOfOption:true},

  //3
  {option:"3", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Ты так сказал только потому что у долбанной Урсулы такая же?", emotion:characters["phoebe"].sittingAngry, achievement:achievements[3]},
    {text:"Ахахах, успокойся, я шучу!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Не думала, что ты и правда будешь угадывать!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Ты что, не видел надпись? Все вульвы уникальны!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Но если реально хочешь знать...", emotion:characters["phoebe"].sittingThinkingCoffee},
    {text:"Тут тяжело найти что-то похожее...", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"Я бы сказала она немного похожа на бургер", emotion:characters["phoebe"].sittingNeutralCoffee},
  ]
  },
  {option:"3", endOfOption:true},

  //7
  {option:"7", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Не, но я знала одну девчонку с 7...", emotion:characters["phoebe"].sittingThinkingCoffee},
    {text:"Хахаха, я не думала, что ты правда будешь угадывать!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Ты что, не видел надпись? Все вульвы уникальны!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"Но если реально хочешь знать...", emotion:characters["phoebe"].sittingThinkingCoffee},
    {text:"Тут тяжело найти что-то похожее...", emotion:characters["phoebe"].sittingSmilingCoffee},
    {text:"Я бы сказала она немного похожа на бургер", emotion:characters["phoebe"].sittingNeutralCoffee},
  ]
  },
  {option:"7", endOfOption:true, endOfOptions:true},
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Лол...бургер?", emotion:characters["willie"].sittingSurprised},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Ну да!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Типо такой сочный и вкусный, с кучей овощей и соуса или...", emotion:characters["willie"].sittingSnide},
    {text:"Аккуратненький...", emotion:characters["willie"].sittingNeutral},
    {text:"Типо как чизбургер?", emotion:characters["willie"].sittingNeutral},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Ой, кажется, тест сейчас начнется!", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
{endOfNovel:true}
]
},

{novel:true, background:classroomMainCut_bg_presentation6, startCoordinates:80,
script:[
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true,
  phrases:[
    {text:"Так, а перед тем, как мы начнем, хочу предупредить, что последний вопрос - лично от меня", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Я собираю данные для исследования, которое делаю с коллегой.", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Этот вопрос никак не повлияет на вашу оценку, даже если вы на него не ответите", emotion:characters["profryder"].standingEyebrowsUp},
    {text:"Но если все же ответите, то очень нам поможете!", emotion:characters["profryder"].standingLaughing},
    {text:"Ладненько, ребята, у вас будет 3 минуты на выполнение... Время пошло!!", emotion:characters["profryder"].standingNeutral},
  ]
  },
  {endOfNovel:true}
]
},

{test:true, questions:[
  {question:'Назовите анатомическую структуру отмеченную "?" на картинке ниже', img: question1, answers:["Большие половые губы","Лобок","Малые половые губы"], answer:"a",
  hints: [[  {
      char:"Фиби",  position:"left",
      phrases:[
        {text:"<small><i>Первый вариант</small></i>"},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ],
  [  {
      char:"Вилли",  position:"right",
      phrases:[
        {text:"<small><i>Бля, я сам не знаю</small></i>"},
        {text:"<small><i>Может 2?</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Мисс Райдер",  position:"left",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ]
  ]},

  {question:'Назовите анатомическую структуру отмеченную "?" на картинке ниже', img: question2, answers:["Клитор","Капюшон клитора","Малые половые губы"], answer:"b",
  hints: [[  {
      char:"Фиби",  position:"left",
      phrases:[
        {text:"<small><i>Тут второй</small></i>"},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ],
  [  {
      char:"Вилли",  position:"right",
      phrases:[
        {text:"<small><i>Бля, я сам не знаю</small></i>"},
        {text:"<small><i>Может первый?</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Мисс Райдер",  position:"left",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ]
  ]},

  {question:'Назовите анатомическую структуру отмеченную "?" на картинке ниже', img: question3, answers:["Головка пениса","Большие вестибулярные железы","Малые вестибулярные железы"], answer:"b",
  hints: [[  {
      char:"Фиби",  position:"left",
      phrases:[
        {text:"<small><i>Большие</small></i>"},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ],
  [  {
      char:"Вилли",  position:"right",
      phrases:[
        {text:"<small><i>Бля, я сам не знаю</small></i>"},
        {text:"<small><i>Может влагалище...</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Мисс Райдер",  position:"left",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ]
  ]},
  {question:'Назовите анатомическую структуру отмеченную "?" на картинке ниже', img: question4, answers:["Луковица преддверия","Капюшон клитора","Ножки клитора"], answer:"c",
  hints: [[  {
      char:"Фиби",  position:"left",
      phrases:[
        {text:"<small><i>Это ножки!</small></i>"},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ],
  [  {
      char:"Вилли",  position:"right",
      phrases:[
        {text:"<small><i>Бля, я сам не знаю</small></i>"},
        {text:"<small><i>Вроде как.. клитор?...</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Мисс Райдер",  position:"left",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ]
  ]},

  {question:"<i>Клитор</i> отвечает за..", answers:["Мочеиспускание","Сексуальное возбуждение","Клитора не существует"], answer:"b",
  hints: [[  {
      char:"Фиби",  position:"left",
      phrases:[
        {text:"<small><i>Возбуждение, конечно!</small></i>"},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ],
  [  {
      char:"Вилли",  position:"right",
      phrases:[
        {text:"<small><i>Бля, я забыл..</small></i>"},
        {text:"<small><i>Может, третье?</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Мисс Райдер",  position:"left",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ]
  ]},

  {question:"Все вульвы...", answers:["Уникальные","Одинаковые","Сочные"], answer:"a",
  hints: [[  {
      char:"Фиби",  position:"left",
      phrases:[
        {text:"<small><i>Уникальные</small></i>"},
        {text:"<small><i>Но сочные тоже хорошо звучит</small></i>"},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ],
  [  {
      char:"Вилли",  position:"right",
      phrases:[
        {text:"<small><i>Бля, не знаю...</small></i>"},
        {text:"<small><i>Пусть будут сочные!</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Мисс Райдер",  position:"left",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ]
  ]},
  {question:"Схоже с какой мужской анатомической структурой работают <i>малые вестибулярные железы</i>?", answers:["Простата","Головка пениса","Яички"], answer:"a",
  hints: [[  {
      char:"Фиби",  position:"left",
      phrases:[
        {text:"<small><i>ХЗ..</small></i>"},
        {text:"<small><i>Простата?</small></i>"},
        {text:"<small><i>Это вообще что...</small></i>"},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ],
  [  {
      char:"Вилли",  position:"right",
      phrases:[
        {text:"<small><i>Бля, я не знаю</small></i>"},
        {text:"<small><i>Помню, что что-то было про сквирт...</small></i>"},
        {text:"<small><i>Наверное яички?</small></i>", achievement:achievements[4]},
      ]
    },
    {
      char:"Мисс Райдер",  position:"left",
      phrases:[
        {text:"Ребята, не списывайте!"},
        {text:"Я хочу оценить ваши реальные знания.."}
      ]
    }
  ]
  ]},
  {question:"Вы когда-нибудь фантазировали о сексе с партнером, значительно старше вас?", answers:["Да, фантазировал_а","Да, был опыт","Нет"], specialQuestion:true},
],
},
{afterTest:true, background:classroomMainCut_bg_presentation6, startCoordinates:0,
  resultAA:[
    {char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
  phrases:[
    {text:"Так-так... Ага", emotion:characters["profryder"].standingLookingTest},
    {text:"Хорошо..", emotion:characters["profryder"].standingSmilingTest},
    {text:"Отлично!", emotion:characters["profryder"].standingLookingTest},
    {text:"Просто супер!", emotion:characters["profryder"].standingSurprisedTest},
    {text:"Ты пока единственный, кто написал вообще без ошибок!", emotion:characters["profryder"].standingSurprisedTest},
    {text:"Я бы сказала у тебя талант...", emotion:characters["profryder"].standingCheckingTestAroused, achievement:achievements[5]},
    {text:"Это ‘5+’, так держать!!!", emotion:characters["profryder"].laughingTestAroused},
  ]
  },
],
resultA:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
phrases:[
  {text:"Так-так... Ага", emotion:characters["profryder"].standingLookingTest},
  {text:"Хорошо..", emotion:characters["profryder"].standingSmilingTest},
  {text:"Отлично!", emotion:characters["profryder"].standingLookingTest},
  {text:"Всего одна ошибка!", emotion:characters["profryder"].standingLookingTest},
  {text:"Это ‘5’, так держать!", emotion:characters["profryder"].standingLookingTest},
]
},
],
resultB:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
phrases:[
  {text:"Так-так... Ага", emotion:characters["profryder"].standingLookingTest},
  {text:"Угу...", emotion:characters["profryder"].standingSmilingTest},
  {text:"Почти все верно!", emotion:characters["profryder"].standingLookingTest},
  {text:"Всего 2 ошибочки", emotion:characters["profryder"].standingLookingTest},
  {text:"Поставлю тебе твердую ‘4’", emotion:characters["profryder"].standingLookingTest},
]
},
],
resultC:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
phrases:[
  {text:"Угу", emotion:characters["profryder"].standingLookingTest},
  {text:"Так-так", emotion:characters["profryder"].standingLookingTest},
  {text:"Неплохо, но у тебя 3 ошибки", emotion:characters["profryder"].standingSmilingTest},
  {text:"Пока что ‘3’", emotion:characters["profryder"].standingLookingTest},
]
},
],
resultD:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1.5, transitionMode: "slow",
phrases:[
  {text:"Угу", emotion:characters["profryder"].standingLookingTest},
  {text:"Так-так", emotion:characters["profryder"].standingNeutralTest},
  {text:"Ммм", emotion:characters["profryder"].standingLookingTest},
  {text:"У тебя довольно много ошибок...", emotion:characters["profryder"].standingNeutralTest},
  {text:"Не переживай, еще наверстаешь", emotion:characters["profryder"].standingSmilingTest},
  {text:"В следущий раз постарайся быть внимательнее", emotion:characters["profryder"].standingNeutralTest},
  {text:"И не стесняйся задавать вопросы!", emotion:characters["profryder"].standingSmilingTest},
]
},
],
answeredSpecialQuestion:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
  phrases:[
    {text:"Ой, да, и спасибо, что ответил на дополнительный вопрос...", emotion:characters["profryder"].standingLookingTest},
    {text:"Это мне ОЧЕНЬ поможет... имею в виду, с исследованием...", emotion:characters["profryder"].standingLookingTest},
  ]
  }
],
answeredSpecialQuestionAroused:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
  phrases:[
    {text:"Ой, да, и спасибо, что ответил на дополнительный вопрос...", emotion:characters["profryder"].standingCheckingTestAroused},
    {text:"Это мне ОЧЕНЬ поможет... имею в виду, с исследованием...", emotion:characters["profryder"].standingCheckingTestAroused},
  ]
  }
],
endingAroused:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
  phrases:[
    {text:"Можешь пока присесть, скоро начнем практическую часть!", emotion:characters["profryder"].laughingTestAroused},
  ]
},
{endOfNovel:true}
],
ending:[
  {char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
  phrases:[
    {text:"Можешь пока присесть, скоро начнем практическую часть!", emotion:characters["profryder"].standingSmilingTest},
  ]
},
{endOfNovel:true}
]},

{novel:true, background:classroomTables_bg, startCoordinates:50,
script:[
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:3, transitionMode: "slow",
  phrases:[
    {text:"Ты всё?", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"Что в последнем? Я вообще не сильна в.. мужских органах", emotion:characters["phoebe"].sittingQuestionCoffee, answers:["Простата","Головка пениса","Яички"]},
  ]
},

//Простата
{option:"Простата", start:true},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:0.5,
phrases:[
  {text:"Оки", emotion:characters["phoebe"].sittingSmilingCoffee, achievement:achievements[6]},
]
},
{option:"Простата", endOfOption:true},

//Головка пениса
{option:"Головка пениса", start:true},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:0.5,
phrases:[
  {text:"Оки", emotion:characters["phoebe"].sittingSmilingCoffee},
]
},
{option:"Penile glans", endOfOption:true},

//Яички
{option:"Яички", start:true},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:0.5,
phrases:[
  {text:"Оки", emotion:characters["phoebe"].sittingSmilingCoffee},
]
},
{option:"Яички", endOfOption:true, endOfOptions:true},

{char:characters["phoebe"],  position:"left", coordinates: 10, speed:0.5,
phrases:[
  {text:"Спасибочки!", emotion:characters["phoebe"].sittingSmilingCoffee},
  {text:"Вот, возьми", emotion:characters["phoebe"].sittingSmilingCoffee},
  {item:sheet, open:true},
  {text:"Если тебе правда интересно...", emotion:characters["phoebe"].sittingSmilingCoffee},
  {item:sheet, close:true},
  {text:"...", emotion:characters["phoebe"].sittingSmilingCoffee},
]
},
{char:characters["willie"],  position:"right",  coordinates: 20, speed:1,
phrases:[
  {text:"Что там, дай посмотреть!", emotion:characters["willie"].sittingSurprised},
  {text:"Вот бы во вкусочке были бы такие...", emotion:characters["willie"].sittingSnide},
  {text:"Я бы их скушал...", emotion:characters["willie"].sittingSnide},
]
},
{endOfNovel:true}
]},

  /*
  {novel:true, background:hall_bg,
  script:[
  {char:characters["phoebe"],  position:"left", startCoordinates:-50, coordinates: 0, speed:0.5,
  phrases:[
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].laughing, animation:true},
    {item:sheet, open:true},
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral},
    {item:sheet, close:true},
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral, achievement:achievements[2]},
  ]
  },
 {
  char:characters["phoebe2"],  position:"left", coordinates: 1, speed:0.7,
  phrases:[
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].laughing, animation:true},
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral},
  ]
  },
  {scene:true, img:hall_bg, start:true},
  {scene:true, name:characters["phoebe2"].nameRu, position:"right",
  phrases:[
    {text:"Lorem ipsum dolor sit amet"},
  ]},
  {scene:true, name:characters["phoebe2"].nameRu, position:"right",
  phrases:[
    {text:"Lorem ipsum dolor sit amet"},
      {text:"??", answers:["yay", "nay", "lol"]}
  ]},
  {option:"yay", start:true},
  {scene:true, name:characters["phoebe2"].nameRu, position:"right",
  phrases:[
    {text:"??"}
  ]},
  {option:"yay", endOfOption:true},
  {option:"nay", start:true},

  {option:"nay", endOfOption:true, endOfOptions:true},
  {scene:true, endOfScene:true},

 {char:characters["phoebe"],  position:"left", coordinates: 0, speed:0.7,
 phrases:[
  {text:"Lorem ipsum dolor sit amet22", emotion:characters["phoebe"].laughing},
  {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral},
  {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].laughing, animation:true},
  {text:"??", answers:["yay", "nay", "lol"], emotion:characters["phoebe"].smile}
 ]
 },
 {option:"yay", start:true},

 {char:characters["phoebe"],  position:"left", coordinates: 0, speed:0.7.2,
 phrases:[
  {text:"u chose yay option", emotion:characters["phoebe"].laughing, animation:true, achievement:achievements[0]},
  {text:"u chose yay option", emotion:characters["phoebe"].smile},
 ]
 },
 {option:"yay", endOfOption:true},

 {option:"nay", start:true},
 {char:characters["phoebe"],  position:"right", coordinates: -50, speed:0.7,
 phrases:[
  {text:"u chose nay option", emotion:characters["phoebe"].smile}
 ]
 },
 {option:"nay", endOfOption:true},

 {option:"lol", start:true},
 {char:characters["phoebe"],  position:"left", coordinates: -50, speed:0.7.2,
 phrases:[
  {text:"u chose lol option", emotion:characters["phoebe"].smile}
 ]
 },
 {option:"lol", endOfOption:true, endOfOptions:true},

 {
 char:characters["phoebe"],  position:"left", coordinates: 0, speed:0.7.2,
 phrases:[
  {text:"endgf", emotion:characters["phoebe"].smile}
 ]
 }
]
},
*/

];

export default chapter1ru;
